import _get from 'lodash/get';
import { defineFetch } from 'resift';
import { mergeLoading, mergeSuccess, mergeError } from '@sift/resift/redux/FetchUtils';

// ------------------------------------
// Constants
// ------------------------------------
export const SEARCH_PEOPLE_FETCH = 'SEARCH_PEOPLE_FETCH';
export const SEARCH_PEOPLE_FETCH_SUCCESS = 'SEARCH_PEOPLE_FETCH_SUCCESS';
export const SEARCH_PEOPLE_FETCH_ERROR = 'SEARCH_PEOPLE_FETCH_ERROR';

// ------------------------------------
// Actions
// ------------------------------------

/**
 * Fetch a search query
 *
 * @param {object} params The params of the search query.
 *  {
 *    q: string,
 *    ...filters,
 *    ...pagination
 *  }
 *
 */
export function fetchSearchPeople(query, identifier) {
  return {
    type: SEARCH_PEOPLE_FETCH,
    identifier: identifier || 'search',
    payload: {
      query,
    },
  };
}

export const makeHeadcountFetch = defineFetch({
  displayName: 'Get Headcount',
  make: () => ({
    key: [],
    request: () => async ({ http }) => {
      const data = await http({
        method: 'GET',
        route: '/search/people',
      });
      return _get(data, 'totalLength', 0);
    },
  }),
});

// ------------------------------------
// Action Handlers
// ------------------------------------
const ACTION_HANDLERS = {
  [SEARCH_PEOPLE_FETCH]: (state, action) => mergeLoading(state, action),
  [SEARCH_PEOPLE_FETCH_SUCCESS]: (state, action) => mergeSuccess(state, action),
  [SEARCH_PEOPLE_FETCH_ERROR]: (state, action) => mergeError(state, action),
};

// ------------------------------------
// Reducer
// ------------------------------------
export const initialState = {
  objects: {},
  fetches: {},
};

export default function SearchReducer(state = initialState, action) {
  const handler = ACTION_HANDLERS[action.type];

  return handler ? handler(state, action) : state;
}
